import {
  SET_CAPTCHA_RESPONSE,
  SET_CAPTCHA_VERIFICATION_ERROR,
} from 'constants/captcha';

type CaptchaAction =
  | {
      type: typeof SET_CAPTCHA_RESPONSE;
      payload: {
        response: string;
      };
    }
  | {
      type: typeof SET_CAPTCHA_VERIFICATION_ERROR;
      payload: {
        verificationError: boolean;
      };
    };

type State = {
  response: string;
  verificationError: boolean;
};

const initialState: State = {
  response: '',
  verificationError: false,
};

const captcha = (state: State = initialState, action: CaptchaAction): State => {
  switch (action.type) {
    case SET_CAPTCHA_RESPONSE:
      return { ...state, response: action.payload.response };
    case SET_CAPTCHA_VERIFICATION_ERROR:
      return { ...state, verificationError: action.payload.verificationError };
    default:
      return state;
  }
};

export { captcha };
